import { render, staticRenderFns } from "./noticeComponent.vue?vue&type=template&id=a2766760&scoped=true"
import script from "./noticeComponent.vue?vue&type=script&lang=js"
export * from "./noticeComponent.vue?vue&type=script&lang=js"
import style0 from "./noticeComponent.vue?vue&type=style&index=0&id=a2766760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2766760",
  null
  
)

export default component.exports